
import { computed } from "vue";

export default {
  props: {
    value: Number,
    options: null,
    label: null,
  },
  data() {
    return {
      SortData: [
        { value: 1, label: "محذوف" },
        { value: 2, label: "غير محذوف" },
      ],
    };
  },
  setup(props, { emit }) {
    const MyValue = computed({
      get() {
        return props.value;
      },
      set(newValue) {
        emit("update:value", newValue);
      },
    });

    return {
      MyValue,
    };
  },
};
